import { render } from "./Fields.vue?vue&type=template&id=668b86d6&ts=true"
import script from "./Fields.vue?vue&type=script&lang=ts"
export * from "./Fields.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__